module.exports = __webpack_public_path__ + "static/media/CaveatBrush.f568f296.ttf";